import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DP_NEWS_LIST_FEATURE, NewsListState } from './news-list-state.type';

const featureSelector = createFeatureSelector<NewsListState>(DP_NEWS_LIST_FEATURE);

export const newsListSelector = createSelector(featureSelector, ({ newsList }) => newsList);
export const newsListMaxItemsSelector = createSelector(featureSelector, ({ cursor, rowCount }) => cursor * rowCount);
export const newsListExpandableSelector = createSelector(
  featureSelector,
  ({ newsList, cursor, rowCount }) => newsList.length > cursor * rowCount,
);
